import CustomTextField from "../../../common/CustomTextField";
import { withStyles } from "@material-ui/core/styles";
import DetailsRenderer from "./DetailsRenderer";
import { Typography, Divider } from "@material-ui/core";
import { CONSIGNEE_LABEL_LIST, SHIPPER_LABEL_LIST, LOADING_ZONE_LIST } from "../../constants";
import ShipmentDetailsHeader from "../../../common/ShipmentDetailsHeader";
import BadgeList from "./BadgeList";
import CustomToggleButtonGroup from "./CustomToggleButtonGroup";
import ManifestProDetails from './ManifestProDetails';
import MoveProWarning from './MoveProWarning';

const styles = (theme) => ({
  sectionHeaderText: {
    opacity: 0.6,
    fontSize: 10,
    fontWeight: 600,
    marginBottom: 16,
    marginTop: 16,
    color: theme.TextColor,
    letterSpacing: 1.5,
  },
  divider: {
    background: theme.gridIconBorderColor,
    height: 0.5,
  },
  fullWidth: { width: "100%", marginTop: 8 },
});

const getDetails = (detailList, shipmentData) => {
  return detailList.map((field) => ({
    label: field.label,
    value: field.formatter 
      ? field.formatter(shipmentData[field.fieldName]) 
      : shipmentData[field.fieldName]
  }));
};
const ProDetails = ({
  classes,
  handleChange,
  loadingZone,
  shipmentData,
  isProInAnotherManifest,
  isCompletedPro,
  newManifest,
  proAlreadyInManifest
}) => {
  const { pieces, hu, weight, cube, manifestNumber, trailerNumber, driverNumber, driverName } =
    shipmentData;
  return (
    <>
      {isProInAnotherManifest && (
        <ManifestProDetails
          manifestNumber={manifestNumber}
          trailerNumber={trailerNumber}
          driverNumber={driverNumber}
          driverName={driverName}
          proAlreadyInManifest={proAlreadyInManifest}
        />
      )}
      <ShipmentDetailsHeader proId={shipmentData.proId} hideDetailsMenu />
      <BadgeList cube={cube} hu={hu} weight={weight} pieces={pieces} />
      <Typography className={classes.sectionHeaderText}>
        LOADING ZONE
      </Typography>
      <CustomToggleButtonGroup
        options={LOADING_ZONE_LIST.map(option => ({label: option, value: option}))}
        handleChange={handleChange}
        value={loadingZone}
      />
      <Typography className={classes.sectionHeaderText}>
        CONSIGNEE DETAILS
      </Typography>
      <DetailsRenderer data={getDetails(CONSIGNEE_LABEL_LIST, shipmentData)} />
      <Divider className={classes.divider} />
      <Typography className={classes.sectionHeaderText}>
        SHIPPER DETAILS
      </Typography>
      <DetailsRenderer data={getDetails(SHIPPER_LABEL_LIST, shipmentData)} />
      <Typography className={classes.sectionHeaderText}>
        SPECIAL INSTRUCTIONS
      </Typography>
      <CustomTextField
        className={classes.fullWidth}
        id="specialInstructions"
        defaultValue={shipmentData.specialInstruction}
        multiline
        disabled
        rows={4}
      />
      {isProInAnotherManifest && !isCompletedPro && (
        <MoveProWarning existingManifest={manifestNumber} newManifest={newManifest} />
      )}
    </>
  );
};

export default withStyles(styles)(ProDetails);
